<template>
<div class="position-relative overflow-hidden" :dir="isHebrew ? 'rtl' : 'ltr'">
    <NavBar/>
    <div>
      <img
        alt=""
        class="background-image"
        src="https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fcircles-background.png?alt=media&token=d420088e-66c6-4c95-bd3b-2f218dd36aba">
    </div>
    <ImageBanner 
                 v-if="isSubdomain"
                 :backgroundImage= "'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fride-info-banner.jpg?alt=media&token=b765e21f-2604-4874-a029-3453357e4897'"
                 :paragraph="t('rideInfoSubdomainParagraph')"
                 size="240px" :title="t('rideInfoPageTitle')"/>
    <ImageBanner v-else
                 :backgroundImage= "'https://firebasestorage.googleapis.com/v0/b/tripplanner-308b3.appspot.com/o/page_images%2Fride-info-banner.jpg?alt=media&token=b765e21f-2604-4874-a029-3453357e4897'"
                 :paragraph="t('rideInfoParagraph')"
                 size="240px" :title="t('rideInfoPageTitle')"/>
  <b-container>
    <b-row class="justify-content-center">
      <b-col col md="6">
        <button
          v-if="isUserManager && !isRideInformationEditMode && !isFirstTimeAddingImages"
          type="button"
          class="create-from-document-link"
          @click="goToImportFromDocument"
        >
          <i class="fa-solid fa-file-arrow-up" aria-hidden="true"></i>
          {{ t('rideInfoCreateFromDocumentLink') }}
        </button>
        <b-form>
          <b-form-group
            v-if="this.isUserManager && !isFirstTimeAddingImages && !isRideInformationEditMode"
            id="label-details"
            :class="['d-flex align-items-center', isHebrew ? 'text-right flex-row-reverse' : 'text-left flex-row-reverse']"
            :label="t('rideInfoPrivateRideLabel')"
            label-for="checkbox-1">
            <b-form-checkbox
              id="checkbox-1"
              class="checkbox-right checkbox-custom mb-2 flex-shrink-0"
              name="checkbox-1"
              size="lg"
              v-model="publickRideCheckBox"
              :unchecked-value=true
              :value=false>
            </b-form-checkbox>
          </b-form-group>
          <b-form-group
            v-if="this.isUserSubdomainManager &&
                  this.isUserManager &&
                  !isFirstTimeAddingImages"
            id="label-details2"
            :class="isHebrew ? 'text-right' : 'text-left'"
            label-for="checkbox-2">
            <div :class="['d-flex align-items-start', isHebrew ? 'flex-row-reverse' : 'flex-row-reverse']">
              <div class="flex-grow-1">
                <label for="checkbox-2" class="mb-1">{{ t('rideInfoWhiteLabelLabel') }}</label>
                <small class="d-block text-muted mb-2" style="font-size: 0.875rem;" v-html="t('rideInfoWhiteLabelHint')"></small>
              </div>
              <b-form-checkbox
                id="checkbox-2"
                class="checkbox-right checkbox-custom mb-2 flex-shrink-0"
                name="checkbox-2"
                size="lg"
                v-model="subdomainCheckBox"
                :checked-value="true"
                :unchecked-value="false">
              </b-form-checkbox>
            </div>
          </b-form-group>
            <b-form-group
              v-if="!isFirstTimeAddingImages"
              id="input-group-1"
              :class="isHebrew ? 'text-right' : 'text-left'"
              :label="datePickerPlaceholder"
              label-for="input-1"
          >
          <flat-pickr
            v-model="date"
            id="example-datepicker"
            ref="datePicker"
            :class="['form-control border-primary rounded-2 py-1', isHebrew ? 'text-right' : 'text-left']"
            :placeholder="datePickerPlaceholder"
            :config=datePickerConfig
            style="direction: ltr;"
          >
          </flat-pickr>
          </b-form-group>
          <b-form-group
              v-if="!isSubdomain"
              id="label-title"
              :class="isHebrew ? 'text-right' : 'text-left'"
              :label="t('rideInfoTitleLabel')"
              label-for="title">
            <b-form-input
                v-model="localRideInformationTitle"
                id="title"
                :class="['form-control border-primary rounded-2 py-4', isHebrew ? 'text-right' : 'text-left']"
                :placeholder="t('rideInfoTitlePlaceholder')"
                required
                type="text"
                :style="{ direction: isHebrew ? 'rtl' : 'ltr' }"
            ></b-form-input>
          </b-form-group>
          <b-form-group
              v-if="!isSubdomain"
              id="label-age"
              :class="isHebrew ? 'text-right' : 'text-left'"
              :label="t('rideInfoAgeLabel')"
              label-for="age">
            <DropdownWithSelect :col-size=4
                                :placeholder="t('rideInfoAgePlaceholder')"
              >
              </DropdownWithSelect>
            <div
              v-if="ageCompositionSummary"
              class="ride-info-age-summary border border-primary rounded-2 p-3 mt-2"
              :class="isHebrew ? 'text-right' : 'text-left'"
              :dir="isHebrew ? 'rtl' : 'ltr'">
              <div class="ride-info-age-summary-label mb-1">{{ t('rideInfoAgeSummaryLabel') }}:</div>
              <div
                v-for="(line, i) in ageCompositionSummary"
                :key="i"
                class="ride-info-age-summary-line">
                {{ line }}
              </div>
            </div>
          </b-form-group>

          <!-- Only for an existing ride: a ride being created has no id to save a profile against.
               Shown to managers, the same audience as the chat panel itself
               (SingleRideWithMap). The profile only has a meaning for managers
               who can reach the AI. -->
          <div
            v-if="isRideInformationEditMode && isUserManager"
            id="label-trip-profile"
            class="ride-info-trip-profile mb-4"
            :class="isHebrew ? 'text-right' : 'text-left'"
            :dir="isHebrew ? 'rtl' : 'ltr'">
            <!-- Only the six fields collapse. The title and the explanation
                 stay visible, or a manager who has never opened this has no
                 way to know what it is. The arrows are vertical so they read
                 the same in RTL. -->
            <div class="ride-info-trip-profile-title">{{ t('rideInformationProfileSection') }}</div>
            <p class="ride-info-trip-profile-hint">{{ t('rideInformationProfileHint') }}</p>
            <button
              type="button"
              class="ride-info-trip-profile-toggle"
              :aria-expanded="tripProfileOpen ? 'true' : 'false'"
              aria-controls="trip-profile-body"
              @click="tripProfileOpen = !tripProfileOpen">
              <span>{{ tripProfileOpen ? t('rideInformationProfileHide') : t('rideInformationProfileShow') }}</span>
              <span class="ride-info-trip-profile-caret">{{ tripProfileOpen ? '▴' : '▾' }}</span>
            </button>
            <div v-if="tripProfileOpen" id="trip-profile-body" class="ride-info-trip-profile-body">
              <TripProfileEditor
                :key="tripProfileEditorKey"
                :profile="rideInformationAiTripProfile"
                :embedded="false"
                :show-actions="false"
                @change="onTripProfileDraftChange" />
              <div v-if="tripProfileStatus === 'failed'" class="ride-info-trip-profile-error" role="alert">
                {{ t('aiChatProfileSaveFailed') }}
              </div>
            </div>
          </div>

          <div
            v-if="!isSubdomain">
            <InsertLinkToTextbox
              :value="localRideInformationText"
              :setValue="val => localRideInformationText = val"
              textareaRef="ride_information_editor"
            />

            <b-form-group
                id="label-details"
                :class="['space_for_add_link', isHebrew ? 'text-right' : 'text-left']"
                :label="t('rideInfoDetailsLabel')"
                label-for="albumLink"
            >

              <b-form-textarea
                  v-model="localRideInformationText"
                  ref="ride_information_editor"
                  id="textarea"
                  class="border-primary rounded-2 p-3"
                  max-rows="6"
                  :placeholder="t('rideInfoDetailsPlaceholder')"
                  rows="4"
                  :style="{ direction: isHebrew ? 'rtl' : 'ltr' }"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group
                id="label-language"
                :class="isHebrew ? 'text-right' : 'text-left'"
                :label="t('rideInfoLanguageLabel')"
                label-for="ride-language"
            >
              <b-form-select
                  v-model="localRideInformationLanguage"
                  id="ride-language"
                  :class="['form-control border-primary rounded-2 py-2', isHebrew ? 'text-right' : 'text-left']"
                  :options="languageOptions"
                  :style="{ direction: isHebrew ? 'rtl' : 'ltr' }"
              ></b-form-select>
            </b-form-group>
          </div>
          <b-form-group
              v-if="!(isSubdomain || isUserManager)"
              id="label-details"
              :class="['justify-content-end d-flex align-items-center', isHebrew ? 'text-right' : 'text-left']"
              :label="t('rideInfoPhysicalDisabilitiesLabel')"
              label-for="checkbox-3">
            <b-form-checkbox
                id="checkbox-3"
                class="checkbox-right ml-2 checkbox-custom mb-2"
                name="checkbox-3"
                size="lg"
                v-model="physicalDisabilities"
                :unchecked-value=false
                :value=true>
            </b-form-checkbox>
          </b-form-group>
          <b-form-group
              v-if="isRideInformationEditMode && isUserManager"
              id="label-presentation-design"
              :class="isHebrew ? 'text-right' : 'text-left'"
              :label="t('rideInfoDesignLabel')">
            <div class="design-picker" role="radiogroup" :aria-label="t('rideInfoDesignLabel')">
              <button
                  v-for="design in presentationDesigns"
                  :key="design.id"
                  type="button"
                  role="radio"
                  :aria-checked="localPresentationDesign === design.id ? 'true' : 'false'"
                  :class="['design-option', { 'design-option-selected': localPresentationDesign === design.id }]"
                  @click="localPresentationDesign = design.id">
                <component :is="design.preview"/>
                <span class="design-option-name">{{ t(design.nameKey) }}</span>
                <span class="design-option-text">{{ t(design.textKey) }}</span>
              </button>
            </div>
          </b-form-group>
          <b-form-group
              v-if="isRideInformationEditMode && isUserManager"
              id="label-top-page-image"
              :class="isHebrew ? 'text-right' : 'text-left'"
              :label="t('rideInfoTopPageImageLabel')"
              label-for="top-page-image-input">
            <div class="w-100 d-flex flex-column align-items-start">
              <div v-if="localTopPageImageUrl" class="mb-2 w-100">
                <img
                  :src="localTopPageImageUrl"
                  :alt="t('rideInfoTopPageImageAlt')"
                  class="top-page-image-preview img-fluid rounded">
              </div>
              <div class="d-flex align-items-center gap-2">
                <label class="btn btn-outline-primary mb-0">
                  <input
                    id="top-page-image-input"
                    type="file"
                    accept="image/*"
                    class="d-none"
                    @change="uploadTopPageImage">
                  <span v-if="!isTopPageImageUploading">
                    {{ localTopPageImageUrl ? t('rideInfoReplaceTopImage') : t('rideInfoUploadTopImage') }}
                  </span>
                  <span v-else>
                    {{ t('rideInfoUploading') }} {{ Math.round(topPageImageUploadValue) }}%
                  </span>
                </label>
                <button
                  type="button"
                  class="top-image-info-btn"
                  @click="showTopImageInfo = !showTopImageInfo"
                >
                  <i class="fas fa-info-circle" style="font-size:1em; vertical-align:middle; display:inline-block;"></i>
                  {{ t('rideInfoMoreInfo') }}
                </button>
              </div>
              <div
                v-if="isTopPageImageUploading"
                class="top-page-image-progress mt-2">
                <div
                  class="top-page-image-progress-bar"
                  :style="{ width: topPageImageUploadValue + '%' }">
                </div>
              </div>
              <div v-show="showTopImageInfo" class="top-page-image-info mt-2" v-html="t('rideInfoTopImageHelp')"></div>
            </div>
          </b-form-group>
          <b-form-group
              v-if="isRideInformationEditMode && !isSubdomain"
              id="label-cover-image"
              :class="isHebrew ? 'text-right' : 'text-left'">
            <div class="cover-image-section">
              <div class="cover-image-header">
                <div class="cover-image-header-text">
                  <span class="cover-image-label">{{ t('rideInfoCoverImageLabel') }}</span>
                  <small class="cover-image-subtitle">
                    <i class="fab fa-whatsapp cover-icon-whatsapp"></i>
                    <i class="fab fa-facebook cover-icon-facebook"></i>
                  </small>
                </div>
                <label class="btn btn-outline-primary btn-sm cover-upload-btn mb-0">
                  <input
                    type="file"
                    accept="image/*"
                    class="d-none"
                    :disabled="preparingCoverImage"
                    @change="uploadCoverImage">
                  <i class="fas fa-upload"></i>
                  {{ localCoverImageUrl ? t('rideInfoCoverImageReplace') : t('rideInfoCoverImageUpload') }}
                </label>
              </div>
              <div v-if="localCoverImageUrl" class="cover-image-current">
                <img :src="localCoverImageUrl" class="cover-image-preview" alt="">
              </div>
              <p v-if="preparingCoverImage" class="cover-gallery-hint">
                {{ t('rideInfoCoverImagePreparing') }}
              </p>
              <p class="cover-image-guidance">{{ t('rideInfoCoverImageGuidance') }}</p>
              <p v-if="coverImageError" class="cover-gallery-warning">
                {{ coverImageError }}
              </p>
            </div>
          </b-form-group>
          <b-form-group
              v-if="isRideInformationEditMode && isUserManager"
              id="label-ride-media"
              :class="isHebrew ? 'text-right' : 'text-left'"
              :label="t('rideInfoMediaLabel')">
            <p class="ride-media-hint">{{ t('rideInfoMediaHint') }}</p>
            <VideoUpload
              v-model="localVideoUrl"
              :entity-id="rideInformationId"
              entity-type-prefix="ride_id"
              storage-folder="videos_and_audios"
              instance-id="ride"
              @upload-progress="isVideoUploading = true"
              @uploaded="isVideoUploading = false"
              @removed="isVideoUploading = false"
              @upload-error="isVideoUploading = false"
            />
            <AudioUpload
              v-model="localAudioUrl"
              :entity-id="rideInformationId"
              entity-type-prefix="ride_id"
              storage-folder="videos_and_audios"
              instance-id="ride"
              @upload-progress="isAudioUploading = true"
              @uploaded="isAudioUploading = false"
              @removed="isAudioUploading = false"
              @upload-error="isAudioUploading = false"
            />
          </b-form-group>
          <b-form-group
              v-if="isRideInformationEditMode"
              id="label-details-lock"
              :class="['d-flex align-items-center', isHebrew ? 'text-right justify-content-end flex-row-reverse' : 'text-left justify-content-start flex-row']"
              :label="t('rideInfoLockRideLabel')"
              label-for="lock-icon">
            <button
                id="lock-icon"
                class="lock-ride-button btn p-0 ml-2 mb-2"
                :class="{ 'locked': rideInformationIsLocked, 'loading': isLocking }"
                @click="toggleRideLock"
                :disabled="isLocking"
                type="button">
              <span v-if="isLocking" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span v-else-if="rideInformationIsLocked" class="material-icons lock-icon-locked">lock</span>
              <span v-else class="material-icons lock-icon-unlocked">lock_open</span>
            </button>
          </b-form-group>
        </b-form>

        <PrimaryButton
          v-if="isFirstTimeAddingImages"
          class="w-100 mb-5"
          @click="this.startAddingTheAccommodations"
        >
          {{ t('rideInfoSaveAndContinue') }}
        </PrimaryButton>
        <div  v-else-if ="isRideInformationEditMode" >
          <PrimaryButton
            class="w-100 mb-5 internall_subdomain_collor"
            :disabled="isTopPageImageUploading || !topPageImageIsReady || isVideoUploading || isAudioUploading"
            @click="handleUpdateRideInformation"
          >
            {{ t('rideInfoSave') }}
          </PrimaryButton>
          <SecondaryButton
            :callBack="ReturnToSingleRide"
            class="w-100 mb-5"
          >
            {{ t('rideInfoBackWithoutSave') }}
          </SecondaryButton>
        </div>
        <div v-else>
          <div
            v-if="createRideValidationError"
            class="ride-info-validation-error mb-3"
            :class="isHebrew ? 'text-right' : 'text-left'">
            {{ createRideValidationError }}
          </div>
          <PrimaryButton
            @click="submitCreateRide"
            class="w-100 mb-5"
          >
            {{ t('rideInfoContinue') }}
          </PrimaryButton>
        </div>
      </b-col>
    </b-row>
  </b-container>
  <AppFooter
    v-if="!isSubdomain"
  />
</div>
</template>

<script>
import ImageBanner from "@/components/ImageBanner/ImageBanner.vue";
import PrimaryButton from "@/components/Buttons/PrimaryButton.vue";
import NavBar from "@/components/NavBar.vue";
import AppFooter from "@/components/Template/AppFooter.vue";
import DropdownWithSelect from "@/components/Buttons/DropdownWithSelect.vue";
import flatPickr from "vue-flatpickr-component";
import SecondaryButton from "@/components/Buttons/SecondaryButton.vue";
import InsertLinkToTextbox from '@/components/InsertLinkToTextbox.vue';
import VideoUpload from '@/components/VideoUpload.vue';
import AudioUpload from '@/components/AudioUpload.vue';
import TripProfileEditor from '@/components/TripProfileEditor.vue';
import { saveTripProfile } from '@/api/tripProfile';
import firebase from 'firebase/app';
import 'firebase/storage';

import { mapActions, mapGetters } from 'vuex';
import { translationMixin } from '@/mixins/translationMixin';
import { rideLanguageOptions } from '@/common/rideLanguageOptions';
import { DESIGN_LIST } from '@/designs';

import { INTERNAL_HOME_PATH } from '@/common/appHome';
import { buildShareImageFromFile } from '@/common/socialShareImage';
export default {
  name: 'RideInformation',
  mixins: [translationMixin],
  components: {
    DropdownWithSelect,
    AppFooter,
    PrimaryButton,
    ImageBanner,
    NavBar,
    flatPickr,
    SecondaryButton,
    InsertLinkToTextbox,
    VideoUpload,
    AudioUpload,
    TripProfileEditor,
    },
  computed: {...mapGetters([  'isUserManager',
                              'userId',
                              'userRole',
                              'rideInformationTitle',
                              'rideInformationSherdPhotosAlbomLink',
                              'rideInformationText',
                              'rideInformationPhysicalDisabilities',
                              'rideInformationCheckIn',
                              'rideInformationCheckOut',
                              'isRideInformationEditMode',
                              'isFirstTimeAddingImages',
                              'isAppLoggedIn',
                              'rideInformationPublick',
                              'isUserSubdomainManager',
                              'rideInformationSubdomain',
                              'rideInformationIsLocked',
                              'rideInformationId',
                              'rideInformationAiTripProfile',
                              'rideInformationLanguage',
                              'rideInformationPresentationDesign',
                              'rideInformationTopPageImageUrl',
                              'rideInformationCoverImageUrl',
                              'rideInformationVideoUrl',
                              'rideInformationAudioUrl',
                              'rideInformationNumbrOfAdoult',
                              'rideInformationNumbrOfTeen',
                              'rideInformationNumbrOfChild',
                              'allRide',
                              ]),
              ...mapGetters("theme",  [ "isSubdomain",
                                      ]),

      fromStartFlow() {
        return this.$route.query.from_start === '1';
      },

      ageCompositionSummary() {
        const a = this.rideInformationNumbrOfAdoult || 0;
        const t = this.rideInformationNumbrOfTeen || 0;
        const c = this.rideInformationNumbrOfChild || 0;
        if (a === 0 && t === 0 && c === 0) return null;
        const parts = [];
        if (a > 0) parts.push(`18+: ${a}`);
        if (t > 0) parts.push(`8-18: ${t}`);
        if (c > 0) parts.push(`0-7: ${c}`);
        return parts;
      },

      datePickerConfig:{
        get(){
          if( this.isRideInformationEditMode )
            return { dateFormat:'d-m-Y' }
          return { mode: 'range', dateFormat:'d-m-Y' }
        }
      },
      datePickerPlaceholder(){
        if (this.isRideInformationEditMode)
          return this.t('rideInfoDateStartPlaceholder');
        return this.t('rideInfoDateRangePlaceholder');
      },
      topPageImageHelpText() {
        return this.t('rideInfoTopImageHelp');
      },
      localRideInformationTitle:{
        get () {
          return this.rideInformationTitle
        },
        set (value) {
          this.$store.commit('setRideInformationTitle', value )
        }
      },
      
      localRideInformationText:{
        get () {
          return this.rideInformationText
        },
        set (value) {
          this.$store.commit('setRideInformationText', value )
        }
      },
      date:{
        get () {
          return this.rideInformationCheckIn

        },
        set (value) {
          if (typeof value === 'string') {
            const dateParts = value.match(/\d{1,2}-\d{1,2}-\d{4}/g) || [];
            this.$store.commit('setRideInformationCheckIn', dateParts[0] || null);
            this.$store.commit('setRideInformationCheckOut', dateParts[1] || null);
            return;
          }

          this.$store.commit('setRideInformationCheckIn', value);
          this.$store.commit('setRideInformationCheckOut', null);

        },
      },
      physicalDisabilities:{
        get () {
          return this.rideInformationPhysicalDisabilities;
        },
        set (value) {
          const convertedValue = value ;
          this.$store.commit('setRideRideInformationPhysicalDisabilities', convertedValue)
        }
      },
      publickRideCheckBox:{
        get () {
          return this.rideInformationPublick;
        },
        set (value) {
          const convertedValue = value ;
          this.$store.commit('setRideInformationPublick', convertedValue)
        }
      },
      subdomainCheckBox:{
        get () {
          return this.rideInformationSubdomain;
        },
        set (value) {
          const convertedValue = value ;
          this.$store.commit('setRideInformationSubdomain', convertedValue)
        }
      },
      localRideInformationLanguage:{
        get () {
          return this.rideInformationLanguage;
        },
        set (value) {
          this.$store.commit('setRideInformationLanguage', value)
        }
      },
      localPresentationDesign: {
        get () {
          return this.rideInformationPresentationDesign;
        },
        set (value) {
          this.$store.commit('setRideInformationPresentationDesign', value);
        }
      },
      presentationDesigns() {
        return DESIGN_LIST;
      },
      localTopPageImageUrl: {
        get () {
          return this.rideInformationTopPageImageUrl;
        },
        set (value) {
          this.$store.commit('setRideInformationTopPageImageUrl', value);
        }
      },
      localCoverImageUrl: {
        get () {
          if (this.rideInformationCoverImageUrl) return this.rideInformationCoverImageUrl;
          return null;
        },
        set (value) {
          this.$store.commit('setRideInformationCoverImageUrl', value);
        }
      },
      localVideoUrl: {
        get () {
          return this.rideInformationVideoUrl;
        },
        set (value) {
          this.$store.commit('setRideInformationVideoUrl', value);
        }
      },
      localAudioUrl: {
        get () {
          return this.rideInformationAudioUrl;
        },
        set (value) {
          this.$store.commit('setRideInformationAudioUrl', value);
        }
      },
      languageOptions() {
        return rideLanguageOptions(this.t);
      },
    },
    data() {
      return {
        isLocking: false,
        isTopPageImageUploading: false,
        topPageImageUploadValue: 0,
        topPageImageIsReady: true,
        createRideValidationError: '',
        showTopImageInfo: false,
        preparingCoverImage: false,
        coverImageError: '',
        isVideoUploading: false,
        isAudioUploading: false,
        tripProfileEditorKey: 0,
        tripProfileStatus: '',
        tripProfileOpen: false,
        // The editor's draft, kept here so the page's own Save writes it with
        // everything else. Null until the manager actually types something.
        pendingTripProfile: null,
      }
    },
    methods:
    {
    // The manager can supply their own cover instead. The file is local, so the canvas
    // can read it and resize it to something both Facebook and WhatsApp will render.
    async uploadCoverImage(event) {
      const files = event.target.files || event.dataTransfer.files;
      if (!files || !files[0]) return;
      const file = files[0];
      event.target.value = '';

      if (!this.rideInformationId) return;

      this.coverImageError = '';
      this.preparingCoverImage = true;
      try {
        const built = await buildShareImageFromFile(file);
        if (!built.ok) {
          this.coverImageError = built.reason === 'tooSmall'
            ? this.t('rideInfoCoverImageTooSmall')
            : this.t('rideInfoCoverImageFailed');
          return;
        }
        const today = new Date();
        const myTime = today.toUTCString().split(', ')[1].split(' ').join('_');
        const task = firebase.storage()
          .ref(`share_images/${this.rideInformationId}_${myTime}`)
          .put(built.blob);
        await task;
        this.localCoverImageUrl = await task.snapshot.ref.getDownloadURL();
      } catch (error) {
        this.coverImageError = this.t('rideInfoCoverImageFailed');
      } finally {
        this.preparingCoverImage = false;
      }
    },
    ...mapActions([ 'register',
                    'validateAndupdateAppToken',
                    'createRideInformation',
                    'updateRideInformation',
                    'updateRideInformationWithoutPushingToRide',
                    'ReturnToSingleRide',
                    'showModal',
                    'rideInformationLoadDefault',
                    'lockRide',
                    ] ),
    register () {
      this.$store.dispatch('register', { email: this.email, password: this.password })
        .then(() => this.$router.push(INTERNAL_HOME_PATH))
    },
    startAddingTheAccommodations() {
      this.updateRideInformationWithoutPushingToRide()
      this.$router.push('/add_accommodations_image')
    },
    onTripProfileDraftChange(profile) {
      this.pendingTripProfile = profile;
    },
    // Saved by the page's Save button, not a button of its own. Returns false
    // so the caller can tell the manager the ride saved but the profile did
    // not, rather than reporting one success for two writes.
    async saveTripProfileIfChanged() {
      const pending = this.pendingTripProfile;
      if (!pending || !Object.keys(pending).length) return true;
      this.tripProfileStatus = '';
      try {
        const { data } = await saveTripProfile(
          this.$store.getters.apptoken,
          this.rideInformationId,
          pending);
        if (!data || !data.success) throw new Error('save failed');
        this.$store.commit('setRideInformationAiTripProfile', data.ai_trip_profile || {});
        this.pendingTripProfile = null;
        // Rebuild the editor from what was stored, so the "set by you" marks
        // match the saved state instead of the draft that produced it.
        this.tripProfileEditorKey += 1;
        return true;
      } catch (error) {
        this.tripProfileStatus = 'failed';
        return false;
      }
    },
    async toggleRideLock() {
      if (this.isLocking) return;
      
      const newLockStatus = !this.rideInformationIsLocked;
      this.isLocking = true;
      
      // Optimistically update the UI
      this.$store.commit('setRideInformationIsLocked', newLockStatus);
      
      try {
        await this.lockRide({
          rideId: this.rideInformationId,
          isLocked: newLockStatus
        });
      } catch (error) {
        // Revert on error
        this.$store.commit('setRideInformationIsLocked', !newLockStatus);
        this.showModal('error');
        console.error('Failed to lock/unlock ride:', error);
      } finally {
        this.isLocking = false;
      }
    },
    goToImportFromDocument() {
      this.$router.push({
        path: '/import-ride-documents',
        query: this.fromStartFlow ? { from_start: '1' } : {},
      });
    },
    async handleUpdateRideInformation() {
      if (this.isTopPageImageUploading || !this.topPageImageIsReady) {
        alert(this.t('rideInfoWaitForUpload'));
        return;
      }

      // The profile goes with the ride's own Save. It has its own endpoint
      // (update_ride_information_api takes the whole ride form and requires
      // checkIn, which this section has nothing to do with), so it is a second
      // request -- but one button, as far as the manager is concerned.
      await this.saveTripProfileIfChanged();
      await this.updateRideInformation();
    },
    submitCreateRide() {
      this.createRideValidationError = '';
      const title = (this.localRideInformationTitle || '').trim();
      if (!title) {
        this.createRideValidationError = this.t('rideInfoTitleRequired');
        return;
      }

      const { startDate, endDate } = this.getSelectedRideDateRange();

      if (!startDate || !endDate) {
        this.createRideValidationError = this.t('rideInfoDateRangeRequired');
        return;
      }

      const MS_IN_DAY = 24 * 60 * 60 * 1000;
      const dateRangeInDays = Math.ceil((endDate - startDate) / MS_IN_DAY);
      if (dateRangeInDays < 0 || dateRangeInDays >= 60) {
        this.createRideValidationError = this.t('rideInfoDateRangeMax60Days');
        return;
      }

      this.$store.dispatch('createRideInformation', { isFirstRide: this.fromStartFlow });
    },
    getSelectedRideDateRange() {
      const rawParts = [];

      if (typeof this.rideInformationCheckIn === 'string') {
        rawParts.push(...(this.rideInformationCheckIn.match(/\d{1,2}-\d{1,2}-\d{4}/g) || []));
      } else if (this.rideInformationCheckIn) {
        rawParts.push(this.rideInformationCheckIn);
      }

      if (typeof this.rideInformationCheckOut === 'string') {
        rawParts.push(...(this.rideInformationCheckOut.match(/\d{1,2}-\d{1,2}-\d{4}/g) || []));
      } else if (this.rideInformationCheckOut) {
        rawParts.push(this.rideInformationCheckOut);
      }

      const startDate = this.parseDateFromRideInput(rawParts[0]);
      const endDate = this.parseDateFromRideInput(rawParts[1]);

      return { startDate, endDate };
    },
    parseDateFromRideInput(value) {
      if (!value) {
        return null;
      }
      if (value instanceof Date) {
        return value;
      }
      if (typeof value !== 'string') {
        return null;
      }

      const parts = value.split('-');
      if (parts.length !== 3) {
        return null;
      }

      const day = Number(parts[0]);
      const month = Number(parts[1]) - 1;
      const year = Number(parts[2]);
      const parsedDate = new Date(year, month, day);

      if (Number.isNaN(parsedDate.getTime())) {
        return null;
      }

      return parsedDate;
    },
    uploadTopPageImage(e) {
      const files = e.target.files || e.dataTransfer.files;
      if (!files || !files[0]) return;

      const file = files[0];

      if (!this.rideInformationId) {
        // Ride ID is required to build a unique image path
        return;
      }

      // Clear old image and mark as not ready while uploading the new one
      this.$store.commit('setRideInformationTopPageImageUrl', null);
      this.topPageImageIsReady = false;

      const today = new Date();
      const myTime = today.toUTCString().split(', ')[1].split(' ').join('_');
      const storagePath = `top_page_images/${this.rideInformationId}_${myTime}`;
      const storageRef = firebase.storage().ref(storagePath).put(file);

      this.isTopPageImageUploading = true;
      this.topPageImageUploadValue = 0;

      storageRef.on('state_changed',
        snapshot => {
          const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.topPageImageUploadValue = progress;
        },
        error => {
          console.error(error.message);
          this.isTopPageImageUploading = false;
          this.topPageImageUploadValue = 0;
          this.topPageImageIsReady = true;
          alert(this.t('rideInfoUploadError'));
        },
        () => {
          this.topPageImageUploadValue = 100;
          storageRef.snapshot.ref.getDownloadURL().then((url) => {
            this.$store.commit('setRideInformationTopPageImageUrl', url);
            this.isTopPageImageUploading = false;
            this.topPageImageUploadValue = 0;
            this.topPageImageIsReady = true;
          });
        }
      );
    },
  },
  created() {
    if (!this.isAppLoggedIn) {
      this.showModal("pleaseLogInInOrderToEditRide");
    }
    if (!this.isRideInformationEditMode) {
      const defaultRideLanguage = this.getCurrentLanguage === 'en' ? 'english' : 'hebrew';
      this.$store.commit('setRideInformationLanguage', defaultRideLanguage);
    }
    if( this.isUserManager ){
      this.$store.commit('setRideInformationPublick', false)     
    }
    // Only set subdomain default if NOT in edit mode (avoid overriding server data)
    if( this.isUserSubdomainManager && !this.isRideInformationEditMode ){
      this.$store.commit('setRideInformationSubdomain', true)     
    }
  },
  destroyed(){
    this.rideInformationLoadDefault()
  },

  watch: {
    // Watch the loggedIn value
    isAppLoggedIn() {
      if( this.isUserManager ){
        this.$store.commit('setRideInformationPublick', false)     
      }
      // Only set subdomain default if NOT in edit mode (avoid overriding server data)
      if( this.isUserSubdomainManager && !this.isRideInformationEditMode ){
        this.$store.commit('setRideInformationSubdomain', true)     
      }
    },
  },

};
</script>


<style scoped>
.create-from-document-link {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  padding: 0;
  border: 0;
  background: transparent;
  color: #0a6f86;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  cursor: pointer;
}

.custom-height {
  height: 50px; /* Adjust to desired height */
  line-height: 1.5; /* Ensures proper text alignment */
}

#checkbox-1 {
  display: flex;
  align-items: center;
}
#checkbox-2 {
  display: flex;
  align-items: center;
}

.form-control{
  background-color: white !important;
}
.dropdown-menu {
  margin-top: 6px;
  width: 100% !important;
}

.cover-image-section {
  border: 1px solid #dee2e6;
  border-radius: 10px;
  padding: 14px 16px;
  background: #f8f9fa;
}

.cover-image-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 10px;
}

.cover-image-header-text {
  display: flex;
  align-items: center;
  gap: 8px;
}

.cover-image-label {
  font-weight: 600;
  font-size: 0.95rem;
  color: #343a40;
}

.cover-image-subtitle {
  display: flex;
  gap: 5px;
  font-size: 1rem;
}

.cover-icon-whatsapp { color: #25D366; }
.cover-icon-facebook { color: #1877F2; }


.cover-image-current {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
}

.cover-image-preview {
  max-width: 100%;
  max-height: 220px;
  width: auto;
  height: auto;
  display: block;
  border-radius: 8px;
}


.cover-gallery-hint {
  font-size: 0.82rem;
  color: #6c757d;
  margin-bottom: 10px;
}







.ride-media-hint {
  font-size: 0.875rem;
  color: #6c757d;
  margin: 0 0 8px;
}

/* The upload components are sized for the attraction page; match this form's text instead */
#label-ride-media ::v-deep .media-upload-field {
  padding: 0.75rem;
  margin-bottom: 0.75rem;
}

#label-ride-media ::v-deep .media-upload-label {
  font-size: 0.95rem;
  margin-bottom: 0.5rem;
}

#label-ride-media ::v-deep .media-upload-btn {
  font-size: 0.95rem;
  padding: 0.4rem 1rem;
  align-self: flex-start;
}

#label-ride-media ::v-deep .media-upload-progress-text {
  font-size: 0.8rem;
}

.cover-image-guidance {
  font-size: 12px;
  color: #6c757d;
  margin: 0 0 8px;
  line-height: 1.5;
}

.cover-upload-btn {
  display: inline-block;
  cursor: pointer;
}

.cover-gallery-warning {
  font-size: 12px;
  color: #a94442;
  margin: 6px 0 0;
}


.internall_subdomain_collor{
  background: var(--primary-background);
  color: var(--primary-text-color);
}

.space_for_add_link {
    margin-top: .5rem;
}

.lock-ride-button {
    background: transparent;
    border: 2px solid #007bff;
    border-radius: 50%;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    outline: none;
}

.lock-ride-button:hover:not(:disabled) {
    background-color: #007bff;
    transform: scale(1.1);
}

.lock-ride-button:hover:not(:disabled) .material-icons {
    color: white;
}

.lock-ride-button.locked {
    border-color: #ffc107;
    background-color: rgba(255, 193, 7, 0.1);
}

.lock-ride-button.locked:hover:not(:disabled) {
    background-color: #ffc107;
}

.lock-ride-button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.lock-ride-button .material-icons {
    font-size: 28px;
    color: #007bff;
    transition: color 0.3s ease;
}

.lock-ride-button.locked .material-icons {
    color: #856404;
}

.lock-ride-button:hover:not(:disabled) .lock-icon-locked {
    color: white;
}

.lock-ride-button:hover:not(:disabled) .lock-icon-unlocked {
    color: white;
}

.lock-ride-button .spinner-border-sm {
    width: 20px;
    height: 20px;
    border-width: 2px;
}

[dir="ltr"] #label-details-lock {
  flex-direction: row-reverse !important;
  justify-content: flex-end !important;
  text-align: left;
  column-gap: 0.5rem;
}

[dir="ltr"] #label-details-lock {
  flex-direction: row-reverse !important;
  justify-content: flex-end !important;
  text-align: left;
}

.ride-info-age-summary {
  background: rgba(7, 160, 195, 0.08);
  font-size: 1rem;
}

/* A real button, not a bare caret: this is the only way into the fields, so
   it has to look pressable at a glance. */
.ride-info-trip-profile-toggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px;
  border: 1px solid #1976d2;
  border-radius: 6px;
  background: #e8f1fb;
  color: #1976d2;
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
.ride-info-trip-profile-toggle:hover { background: #d7e7f8; }
.ride-info-trip-profile-caret { font-size: 0.85em; }
.ride-info-trip-profile-body { margin-top: 12px; }
.ride-info-trip-profile-title { font-weight: 600; margin-bottom: 4px; }
.ride-info-trip-profile-hint { color: #666; font-size: 0.9em; margin-bottom: 12px; }
.ride-info-trip-profile-saved { color: #2e7d32; margin-top: 8px; }
.ride-info-trip-profile-error { color: #c62828; margin-top: 8px; }
.ride-info-age-summary-label {
  font-weight: 600;
}

.ride-info-age-summary-line {
  line-height: 1.5;
}

.ride-info-age-summary-line + .ride-info-age-summary-line {
  margin-top: 0.25rem;
}

.ride-info-validation-error {
  color: #dc3545;
  font-size: 0.95rem;
}

.design-picker {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 12px;
  width: 100%;
}

.design-option {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 6px;
  padding: 10px 10px 12px;
  border: 2px solid #e2e2e2;
  border-radius: 14px;
  background: #fff;
  text-align: inherit;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.design-option:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.3);
}

.design-option-selected {
  border-color: var(--primary-color, #07A0C3);
  box-shadow: 0 0 0 3px rgba(7, 160, 195, 0.15);
}

.design-option-name {
  font-weight: 700;
  font-size: 16px;
  color: #1d1d1f;
}

.design-option-text {
  font-size: 14px;
  line-height: 1.3;
  color: #6e6e73;
}

.top-page-image-preview {
  max-height: 120px;
  object-fit: cover;
  width: 100%;
}

.top-page-image-upload-wrapper {
  width: 100%;
}

.top-page-image-progress {
  width: 100%;
  height: 4px;
  background: #e0e0e0;
  border-radius: 2px;
  overflow: hidden;
}

.top-page-image-progress-bar {
  height: 100%;
  background: linear-gradient(90deg, #07A0C3, #0AD6A1);
  transition: width 0.3s ease;
}

.help-icon-btn {
  text-decoration: none !important;
  border: none !important;
  cursor: pointer;
}

.top-page-image-help-icon {
  margin-inline-end: 0.5rem;
}

.top-image-info-btn {
  background: none;
  border: none;
  color: #007bff;
  font-size: 0.85em;
  cursor: pointer;
  padding: 0;
  margin-inline-start: 12px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.top-image-info-btn:hover {
  text-decoration: underline;
}

.top-page-image-info {
  font-size: 0.82em;
  color: #6c757d;
  background: #f8f9fa;
  border-radius: 6px;
  padding: 8px 12px;
  line-height: 1.5;
  width: 100%;
}

.help-icon-btn:hover {
  opacity: 0.7;
}

.help-icon-btn:focus {
  box-shadow: none !important;
  outline: none !important;
}

/* Checkbox rows: label at start, checkbox at end (swap for RTL) */
#label-details {
  gap: 0.5rem;
}
#label-details2 .d-flex {
  gap: 0.5rem;
}

::v-deep .popover {
  max-width: 400px;
  line-height: 1.6;
}

[dir="rtl"] ::v-deep .popover,
[dir="rtl"] ::v-deep .popover-body {
  text-align: right;
  direction: rtl;
}

[dir="ltr"] ::v-deep .popover,
[dir="ltr"] ::v-deep .popover-body {
  text-align: left;
  direction: ltr;
}

/* Make placeholder text lighter/faded for title input when focused */
#title:focus::placeholder {
    opacity: 0.4 !important;
}

/* Make placeholder text lighter/faded for textarea when focused */
#textarea:focus::placeholder {
    opacity: 0.4 !important;
}
</style>